import { PurchasingQuoteLineItem } from './purchasing-quote-line-item'

export class PurchasingQuote {
    id!: string
    quoteNumber!: string
    vendor!: number | undefined
    vendorName!: string
    job!: string
    quoteDate!: Date | undefined
    expirationDate!: Date | undefined
    status!: string
    description!: string
    subtotal!: number | undefined
    taxAmount!: number | undefined
    freightAmount!: number | undefined
    total!: number | undefined
    source!: string
    createdBy!: string
    createdOn!: Date | undefined
    archived!: boolean

    lineItems: PurchasingQuoteLineItem[] = []
}
